import styled from 'styled-components';

interface INumberInput {
  value?: string | number;
  onChange: (
    value: string,
    func: React.Dispatch<React.SetStateAction<number | undefined>>
  ) => void;
  onUpArrow: (func: React.Dispatch<React.SetStateAction<number | undefined>>) => void;
  onDownArrow: (func: React.Dispatch<React.SetStateAction<number | undefined>>) => void;
  func: React.Dispatch<React.SetStateAction<undefined | number>>;
}

export const NumberInput = ({
  value,
  onChange,
  onUpArrow,
  onDownArrow,
  func
}: INumberInput) => {
  return (
    <CalculatorContainer>
      <CalculatorInput
        value={value}
        placeholder='0'
        onChange={(e) => {
          const value = e.target.value;
          onChange(value, func);
        }}
        type="number"
        min={0}
        textColor={value === 0 ? '#A2A8B0' : '#26292D'}
      />
      <div
        onKeyDown={() => ''}
        tabIndex={0}
        role="button"
        className="arrow arrow-up"
        onClick={() => onUpArrow(func)}
      />
      <div
        onKeyDown={() => ''}
        tabIndex={0}
        role="button"
        className="arrow arrow-down"
        onClick={() => onDownArrow(func)}
      />
    </CalculatorContainer>
  );
};

const CalculatorContainer = styled.div`
  position: relative;
  height: 100%;
  width: 33%;
  @media (max-width: 600px) {
    width: 48%;
  }
`;

const CalculatorInput = styled.input<{ textColor?: string }>`
  color: ${(props) => props.textColor};
  border: 2px solid #e7e8eb;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 16px 12px 24px;
  font-size: 24px;
  height: 100%;
  width: 100%;
  outline: none;
  &:hover,
  &:active,
  &:focus {
    border: 2px solid #a2a8b0 !important;
  }
  @media (max-width: 450px) {
    font-size: 18px;
    padding: 12px 30px 12px 12px;
  }
  @media (max-width: 360px) {
    font-size: 16px;
    padding: 12px 30px 12px 10px;
  }
`;

export const CalculatorInputRub = styled(CalculatorInput)`
  width: 33%;
  padding-right: 70px;
  @media (max-width: 600px) {
    width: 48%;
  }
  @media (max-width: 450px) {
    padding-right: 45px;
  }
`;
